import { render, staticRenderFns } from "./copybook2.vue?vue&type=template&id=6aaf3a90&scoped=true&"
import script from "./copybook2.vue?vue&type=script&lang=js&"
export * from "./copybook2.vue?vue&type=script&lang=js&"
import style0 from "./copybook2.vue?vue&type=style&index=0&id=6aaf3a90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf3a90",
  null
  
)

export default component.exports